export default __webpack_public_path__ + "static/media/appLogoWord.287d71dc.svg";